angular.module('impactx.cube').directive('ixCubeMenu', function()
{
    return {
        template:'<ng-transclude-replace></ng-transclude-replace>',
        transclude: true,
        controller: 'CubeMenuCtrl',
        controllerAs: 'cubeMenuCtrl'
    }
});